import { Component } from '@angular/core';
import { SessionStat } from '../../../sessions/sessions-stat/sessions-stat.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { Globals } from '../../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { SuperClass } from '../../../../superclass/SuperClass';

@Component({
  selector: 'app-not-logged-in-users',
  templateUrl: './not-logged-in-users.component.html',
  styleUrls: ['./not-logged-in-users.component.css'],
})
export class NotLoggedInUsersComponent extends SuperClass {
  selectedRow: SessionStat;
  display = false;
  start: Date;
  end: Date;
  nasid;
  session: SessionStat[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Dashboards' },
      { label: 'Reporting' },
      {
        label: 'Not Logged In Users',
        routerLink: [{ outlets: { sub: [RouterConst.NOT_LOGGED_IN_USERS] } }],
      },
    ]);
    this.selectedRow = new SessionStat();
  }

  reloadData() {
    this.end = new Date();
    this.start = new Date(this.end.getTime() - 24 * 60 * 60 * 1000);
    this.nasid = '';
    this.getUsers();
  }

  getUsers() {
    const request = {
      start: this.start.getTime(),
      end: this.end.getTime(),
      nasid: this.nasid,
    };
    this.http_getNotLoggedInUsers(
      this.nasid,
      +this.start,
      +this.end,
      (data: any) => {
        console.log('DATA', data);
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.session = data.payload;
        }
      },
    );
  }

  getDate(date) {
    return new Date(date);
  }

  selectRow(e) {}

  unselectRow() {}

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/dashboards/reporting/not-logged-in-users/not-logged-in-users.component.ts